import React from "react";
import { useRef } from "react";
// Components
import ContentContainer from "../../../layouts/ContentContainer/ContentContainer";
import NavBar from "../../../components/NavBar/NavBar";
import Banner from "../../../layouts/Banner/Banner";
// Buttons
import CTAButton from "../../../components/Buttons/CTAButton";
import ScrollToTopButton from "../../../components/Buttons/ScrollToTopButton";
// Assets
import heroInnerImgRight from "../../../assets/imgs/ways-working-page/hero/laptop_Laptop.png";

const Working = () => {
   const pageRef = useRef(null);

   return (
      <div
         ref={pageRef}
         className="page page-book base-page-culture page--font-dark"
      >
         <div className="page-inner">
            <header id="page-three-top" className="header">
               <div className="background-image--working"></div>
               <NavBar />
               <div className="hero">
                  <div className="hero__container hero__container--inner-img">
                     <div className="hero__text">
                        <p className="hero__paragraph">
                           Supportive hybrid work environment; an amazing team
                           and work culture; good management
                        </p>
                     </div>
                     <div className="inner-img inner-img--center-shadow">
                        <img src={heroInnerImgRight} alt="" />
                     </div>
                  </div>
               </div>
            </header>

            <main>
               <ContentContainer>
                  <div className="text-container--2col">
                     <h1 className="heading heading--primary">
                        Our ways of working
                     </h1>
                     <h3 className="heading heading--tertiary">
                        Our assets – IT and internet
                     </h3>
                     <p>
                        We understand that sometimes you may need to use our
                        equipment for personal reasons, either as a result of
                        being at work or not having access outside of Avado. We
                        simply ask that you keep in mind the costs associated
                        with using our equipment (e.g., printers) and the impact
                        that has on our business. We do allow reasonable use of
                        the internet and email; we just ask you keep in mind
                        that you are representing the Avado brand in your
                        communications from Avado accounts.
                     </p>
                     <p>
                        All messages sent or received on the Avado network are
                        monitored, and considered business assets. We therefore
                        ask that all interactions using Avado accounts are
                        appropriate and not offensive.
                     </p>
                     <p>
                        You are welcome to bring your own device to work. If
                        this is something you wish to do, please contact a
                        member of the Tech team for further information.{" "}
                     </p>
                     <br />
                     <br />
                     <h3 className="heading heading--tertiary">Expenses</h3>
                     <p>
                        Check out our Guide to Travel & Expenses, available on
                        the PX Hub, for detailed information about what to do
                        for Expenses
                     </p>
                     <h3 className="heading heading--tertiary">ISO</h3>
                     <p>
                        At Avado, we adopt best practice standards for
                        information security with our ISO-certified Information
                        Security Management System (ISMS). ISO is a rigorous and
                        comprehensive standard for protecting and preserving
                        corporate and business information under the principles
                        of confidentiality, integrity and availability. More
                        information on how we adopt industry best practices and
                        the ISO standard is provided during your on-boarding
                        experience.
                     </p>
                  </div>
               </ContentContainer>

               {/* Banner */}
               <div className="banner">
                  <div className="banner-container">
                     <Banner
                        modifier="banner-ways-working"
                        styleClass="content-container__container--2col"
                     >
                        <div className="text-container--1col text-container--white-bg text-container--small-text-container">
                           <h3 className="">Guides and Commitments</h3>
                           <p className="">
                              We have various Guides and Commitments in place to
                              keep us all aligned with the same level of
                              expectations across Avado. These guides cover
                              areas such as our benefits, time away from work,
                              health and wellbeing, and how we work together to
                              solve problems in relationships at work. For more
                              information, contact your line manager or check
                              out our PX Hub.
                           </p>
                           <CTAButton
                              modifier="primary"
                              openURL="https://floreamlimited.sharepoint.com/PX/SitePages/Your-People-Experience-Team-(PX).aspx"
                              target="_blank"
                              htmlTag="button"
                           >
                              PX Hub
                           </CTAButton>
                        </div>

                        <div></div>
                     </Banner>
                  </div>
               </div>

               <ContentContainer>
                  <ScrollToTopButton parentContainer={pageRef} />
               </ContentContainer>
            </main>
         </div>
      </div>
   );
};

export default Working;
